module.exports = __webpack_public_path__ + "static/img/prescription.0916bc6.png";


//////////////////
// WEBPACK FOOTER
// ./static/prescription.png
// module id = NQU4
// module chunks = 171